import { Money } from "@tsp-domains/money/types";

export function checkIsNumber(input: unknown): input is number {
  return typeof input === "number";
}

export function parseUnknownToNumber(input: unknown, type: "float" | "integer"): number | null {
  if (typeof input === "number") {
    if (Number.isNaN(input)) {
      return null;
    }

    return input;
  }

  if (typeof input === "string") {
    const number = type === "integer" ? parseInt(input, 10) : parseFloat(input);
    if (Number.isNaN(number)) {
      return null;
    }

    return number;
  }

  return null;
}

export function formatNumber(input: Money, delimiter: string, fallback = "N/A"): string {
  const [wholePart, fractionalPart = "0"] = String(input).split(".");
  if (!wholePart) {
    return fallback;
  }

  let buffer = "";
  const wholePartDigits = wholePart.split("");
  const formatedWholePart = wholePartDigits
    .reverse()
    .reduce<Array<string>>((result, value, index) => {
      const isLast = index === wholePartDigits.length - 1;
      const separate = (index + 1) % 3 === 0;

      buffer = value + buffer;
      if (separate || isLast) {
        result.unshift(buffer);
        buffer = "";
      }

      return result;
    }, [])
    .join(" ");

  const formatedFractionalPart = `${fractionalPart}0`.slice(0, 2);

  return `${formatedWholePart}${delimiter}${formatedFractionalPart}`;
}
